<template>
    
    <div class="editUser">
        <ValidationObserver ref="form" v-slot="{handleSubmit}">
            <form @submit.prevent="handleSubmit(send)">
                <vs-row>
                    <vs-col vs-w="6">
                        <div class="p-2">
                            <ValidationProvider vid="name" :name="$t('global.Name')" rules="required|minmax:3,50" v-slot="{ errors }">
                                <label class="text-sm opacity-75">{{$t('global.Name')}}</label>
                                <vs-input
                                    name="name"
                                    class="inputx w-full no_focus"
                                    :placeholder="$t('global.Name')"
                                    v-model="name"
                                />
                                <div class="text-danger text-xs" >{{ errors[0] }}</div>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2">
                            <ValidationProvider vid="email" :name="$t('global.Email')" rules="required|email" v-slot="{ errors }">
                                <label class="text-sm opacity-75">{{$t('global.Email')}}</label>
                                <vs-input
                                    name="email"
                                    class="inputx w-full no_focus"
                                    :placeholder="$t('global.Email')"
                                    v-model.trim="email"
                                />
                                <div class="text-danger text-xs" >{{ errors[0] }}</div>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6" v-if="popupType !== 'editUser'">
                        <div class="p-2">
                            <ValidationProvider vid="password" :name="$t('modals.Password')" :rules="`required|minmax:6,25|is_not:${email}`" v-slot="{ errors }">
                                <label class="text-sm opacity-75">{{$t('modals.Password')}}</label>
                                <password-input
                                    :placeholder="$t('modals.Password')"
                                    name="password"
                                    v-model="password"
                                    @generate="generatePassword"
                                />
                                <div class="text-danger text-xs" >{{ errors[0] }}</div>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6" v-if="popupType !== 'editUser'">
                        <div class="p-2">
                            <ValidationProvider vid="confirm_password" :name="$t('modals.Confirm_password')" :rules="`required|minmax:6,25|is_not:${email}|confirmed:password`" v-slot="{ errors }">
                                <label class="text-sm opacity-75">{{$t('modals.Confirm_password')}}</label>
                                <div class="flex items-center">
                                    <password-input
                                        :placeholder="$t('modals.Confirm_password')"
                                        name="confirm_password"
                                        v-model="confirm_password"
                                        :generator="false"
                                    />
                                </div>
                                <div class="text-danger text-xs" >{{ errors[0] }}</div>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2">
                            <ValidationProvider vid="locale" :name="$t('global.Locale')" rules="required" v-slot="{ errors }">
                                <label class="text-sm opacity-75">{{$t('global.Locale')}}</label>
                                <v-select
                                    ref="select"
                                    :options="locales"
                                    :reduce="test => test.value"
                                    label="text"
                                    name="locale"
                                    :clearable="false"
                                    :placeholder="$t('global.Locale')"
                                    autocomplete
                                    appendToBody
                                    v-model="locale"
                                    :calculate-position="withPopper"
                                />
                                <div class="text-danger text-xs" >{{ errors[0] }}</div>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2">
                            <ValidationProvider tag="div" vid="team" :name="$t('global.Team')" rules="required" v-slot="{ errors }">
                                <label class="text-sm opacity-75">{{$t('global.Team')}}</label>
                                <v-select
                                    ref="select"
                                    :options="teams"
                                    :reduce="test => test.value"
                                    label="text"
                                    name="team"
                                    :clearable="false"
                                    :placeholder="$t('global.Team')"
                                    autocomplete
                                    appendToBody
                                    v-model="team"
                                    :calculate-position="withPopper"
                                />
                                <div class="text-danger text-xs" >{{ errors[0] }}</div>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2">
                            <ValidationProvider vid="role" :name="$t('global.Role')" rules="required" v-slot="{ errors }">
                                <label class="text-sm opacity-75">{{$t('global.Role')}}</label>
                                <v-select
                                    ref="select"
                                    :options="roles"
                                    :reduce="test => test.value"
                                    label="text"
                                    name="role"
                                    :clearable="false"
                                    :placeholder="$t('global.Role')"
                                    autocomplete
                                    appendToBody
                                    v-model="role"
                                    :calculate-position="withPopper"
                                />
                                <div class="text-danger text-xs" >{{ errors[0] }}</div>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="12">
                        <div class="p-2 text-right">
                            <vs-button
                                button="submit"
                                ref="btn"
                            >
                                {{ $t('buttons.Save') }}
                            </vs-button>
                        </div>
                    </vs-col>
                </vs-row>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ErrorHandler from '@/utils/errorHandler'
import vSelect from 'vue-select'
import send from '@/utils/fetch'
import EventBus from '@/store/eventBus'
import {vSelectPosition, utils} from '@/utils/mixins'

export default {
    props: ['popupData', 'popupType', 'popupButton'],

    mixins: [vSelectPosition, utils],

    data() {
        return {
            name: '',
            email: '',
            password: '',
            confirm_password: '',
            locale: null,
            team: null,
            role: null,

            locales: [
                {text: 'UA', value: 'UA'},
                {text: 'RU', value: 'RU'},
                {text: 'EN', value: 'EN'}
            ],
            teams: [],
            roles: []
        }
    },

    components: {
        vSelect,
        ValidationProvider,
        ValidationObserver
    },

    methods: {
        generatePassword(password) {
            this.confirm_password = password
        },

        async send() {
            try {
                const valid = this.$refs.form.validate()
                if(valid) {
                    const data = {
                        name: this.name.trim(),
                        email: this.email.trim(),
                        password: this.password.trim(),
                        confirm_password: this.confirm_password.trim(),
                        locale:  this.locale.trim(),
                        team_id:  this.team,
                        role_id:  this.role
                    }

                    Object.keys(data).map(key => {
                        if(!data[key]) {
                            delete data[key]
                        }
                    })

                    if(this.popupType === 'createUser') {
                        await send(this.$url.user.create, 'POST', {data})
                    }

                    if(this.popupType === 'editUser') {
                        data.hash = this.popupData.hash
                        await send(this.$url.user.update, 'PUT', {data:{...data}})
                    }

                    EventBus.$emit('updateUsers')
                    EventBus.$emit('emitPopupEvent', {type: 'close'})
                }
            } catch (e) {
                if(e.response && e.response.data && e.response.data.result) {
                    const response = e.response.data.result
                    this.$refs.form.setErrors(this.$errors(response))
                }
                new ErrorHandler(e).send
            }
        },

        createOptions(data) {
            return data.map(item => ({text: item.name, value: item.id}))
        },

        async get() {
            try {
                const response = await Promise.all([
                    send(this.$url.role.get, 'GET').then(response => response.data.result),
                    send(this.$url.user.teams, 'GET').then(response => this.createNameById(response.data.result))
                ])

                this.teams = this.createOptions(response[1])
                this.roles = this.createOptions(response[0])
            } catch (e) {
                new ErrorHandler(e).send
            }
        }
    },

    async mounted() {
        try {
            await this.get()

            if(this.popupType === 'editUser') {
                this.name = this.popupData.name
                this.email = this.popupData.email
                this.locale = this.popupData.locale
                this.team = this.popupData.team_id
                this.role = this.popupData.role_id
            }

            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
        }
    }
}
</script>

<style lang="scss">
.vs__dropdown-menu {
    z-index: 999999999;
    position: absolute !important;
}

.heightSelect {

}

.no_focus {
    input {
        &:focus {
            box-shadow: none !important;
            border: 1px solid rgba(0, 0, 0, 0.2) !important;
        }
    }
}
</style>
